export default __webpack_public_path__ + "9e38fee6435189e6754ecde98973b225.png";